import { Footer,  Slider,Accordion,Aboutme, HomePortfolioSection, Testimonial } from '../container';
import Navbar from '../components/Navbar/Navbar'

export default function Home() {
  return (
    <>
    <Navbar/>
    <Slider/>
    <Aboutme/>
    <HomePortfolioSection/>
    <Testimonial/>
    <Accordion/>
    <Footer/>
    </>
  );
}
